<div class="dialog-footer">
  <button type="button" class="btn btn-outline-secondary mt-2" (click)="onCancel()">
    <fa-icon icon="chevron-left"></fa-icon>
    {{ config?.label?.cancel || constantHelper.LBL_ACTION_COMMON_CANCEL | translate }}
  </button>
  <button type="button" class="btn btn-primary float-right mt-2" (click)="onSave()">
    <fa-icon icon="save"></fa-icon>
    {{ config?.label?.save || constantHelper.LBL_ACTION_COMMON_SAVE | translate }}
  </button>
</div>
